import * as fromDatatype from '../datatype-library'


export interface bl_asv_consultation_checklist_detail_line_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    checklist_type: fromDatatype.VarcharDatatypeInterface;
    hdr_guid: fromDatatype.GuidDataFieldInterface;
    txn_date:fromDatatype.TimestampTzDatatypeInterface;
    technician_guid: fromDatatype.GuidDataFieldInterface;
    description: fromDatatype.VarcharDatatypeInterface;
    consultation_status: fromDatatype.VarcharDatatypeInterface;
    created_date:fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    created_by_subject_guid:fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid:fromDatatype.GuidDataFieldInterface
    revision: fromDatatype.RevisionDataFieldInterface;
    vrsn: fromDatatype.VrsnDataFieldInterface;
    namespace:fromDatatype.VarcharDatatypeInterface;
    property_json:fromDatatype.JsonDatatypeInterface;
    acl_config:fromDatatype.JsonDatatypeInterface;
    acl_policy:fromDatatype.JsonDatatypeInterface;
    status: fromDatatype.StatusDataFieldInterface;

}

export class bl_asv_consultation_checklist_detail_line_RowClass implements bl_asv_consultation_checklist_detail_line_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    checklist_type: fromDatatype.VarcharDatatypeInterface;
    hdr_guid: fromDatatype.GuidDataFieldInterface;
    txn_date:fromDatatype.TimestampTzDatatypeInterface;
    technician_guid: fromDatatype.GuidDataFieldInterface;
    description: fromDatatype.VarcharDatatypeInterface;
    consultation_status: fromDatatype.VarcharDatatypeInterface;
    created_date:fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    created_by_subject_guid:fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid:fromDatatype.GuidDataFieldInterface
    revision: fromDatatype.RevisionDataFieldInterface;
    vrsn: fromDatatype.VrsnDataFieldInterface;
    namespace:fromDatatype.VarcharDatatypeInterface;
    property_json:fromDatatype.JsonDatatypeInterface;
    acl_config:fromDatatype.JsonDatatypeInterface;
    acl_policy:fromDatatype.JsonDatatypeInterface;
    status: fromDatatype.StatusDataFieldInterface;
}
